module.exports = __webpack_public_path__ + "static/Grenette-SemiBold-Pro-65fd97949b7dccbc1c09bebd44432896.woff";